// extracted by mini-css-extract-plugin
export default {"container":"orderManagement_container__NTd1m","header":"orderManagement_header__5QPcx","filter":"orderManagement_filter__+mOHi","tableFooter":"orderManagement_tableFooter__mLvgv"};